import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

export const IconReload = ({
    width = '16',
    height = '16',
    className,
    ...rest
}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        {...rest}
    >
        <path
            fillRule="evenodd"
            d="M 12.001 8.001 C 12.002 7.449 12.449 7.002 13.001 7.002 C 13.553 7.002 14 7.449 14.001 8.001 L 14.001 8.027 C 14 9.795 13.222 11.474 11.875 12.619 C 10.527 13.764 8.745 14.26 7 13.975 L 7 15.125 C 7 15.609 6.652 16.001 6.223 16.001 C 6.037 16 5.858 15.927 5.724 15.798 L 2.654 13.208 C 2.446 13.032 2.328 12.772 2.332 12.499 C 2.332 12.209 2.459 11.951 2.654 11.792 L 5.725 9.202 C 5.859 9.073 6.037 9.001 6.223 8.999 C 6.654 8.999 7.001 9.391 7.001 9.875 L 7.001 11.935 C 8.204 12.233 9.478 11.962 10.454 11.199 C 11.431 10.435 12.002 9.265 12.002 8.025 L 12.002 7.999 L 12.001 8.001 Z  M 9 2.077 L 9 0.875 C 9 0.391 9.349 -0.001 9.777 -0.001 C 9.967 -0.001 10.141 0.076 10.276 0.202 L 13.346 2.792 C 13.54 2.952 13.668 3.209 13.668 3.501 C 13.668 3.791 13.541 4.049 13.346 4.208 L 10.275 6.798 C 10.141 6.927 9.963 6.999 9.777 7 C 9.348 7 8.999 6.608 8.999 6.125 L 8.999 4.118 C 7.801 3.821 6.533 4.089 5.557 4.846 C 4.582 5.604 4.008 6.766 3.999 8 C 3.998 8.552 3.551 8.998 2.999 8.998 C 2.448 8.998 2 8.552 1.999 8 L 1.999 7.978 C 2.013 6.217 2.796 4.551 4.142 3.416 C 5.488 2.281 7.263 1.791 9 2.075 L 9 2.077 Z"
        />
    </svg>
);

export default IconReload;
